import "core-js/modules/es.number.constructor.js";
//
//
//
//
import echarts from 'echarts';
import { debounce } from '@/utils';
export default {
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 100
    },
    chartData: {
      // 图表数据
      type: Number,
      default: function _default() {
        return 0;
      }
    },
    legendName: {
      // 图例名称
      type: String,
      default: function _default() {
        return '';
      }
    },
    xAxisData: {
      // x轴数据
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.chart.clear();
        this.initChart();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setOptions: function setOptions(chartData, legendName) {
      var value = chartData; //图上角度数据

      var option = {
        backgroundColor: "rgba(6, 26, 53)",
        title: [{
          text: '{a|' + value + '}{c|%}',
          x: 'center',
          y: '30%',
          textStyle: {
            rich: {
              a: {
                fontSize: 20,
                color: '#0b98ff',
                fontWeight: 'bold'
              },
              c: {
                fontSize: 20,
                color: '#0b98ff',
                fontWeight: 'normal'
              }
            }
          }
        }, {
          text: legendName,
          x: 'center',
          y: '80%',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#0b98ff'
          }
        }],
        series: [//外环
        {
          name: "外环",
          type: 'pie',
          silent: true,
          clockwise: true,
          radius: ['70%', '75%'],
          center: ["50%", "40%"],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            color: '#223755'
          },
          data: [0]
        }, //内环
        {
          name: "内环",
          type: 'pie',
          silent: true,
          clockwise: true,
          radius: ['45%', '46%'],
          center: ["50%", "40%"],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            color: '#414f63'
          },
          data: [0]
        }, //外环
        {
          name: '',
          type: 'pie',
          radius: ['55%', '65%'],
          center: ["50%", "40%"],
          silent: true,
          clockwise: true,
          startAngle: 90,
          label: {
            show: false
          },
          data: [{
            value: value,
            itemStyle: {
              normal: {
                //外环发光
                borderWidth: 0.5,
                shadowBlur: 20,
                borderColor: '#4bf3f9',
                shadowColor: '#9bfeff',
                color: {
                  // 圆环的颜色
                  colorStops: [{
                    offset: 0,
                    color: '#15caff' // 0% 处的颜色

                  }, {
                    offset: 1,
                    color: '#159bfe' // 100% 处的颜色

                  }]
                }
              }
            }
          }, {
            value: 100 - value,
            label: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: "#364662"
              }
            }
          }]
        }]
      };
      this.chart.setOption(option);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.myEchart, 'macarons');
      this.setOptions(this.chartData, this.legendName);
    }
  }
};